// this is an autogenerated file from DesignSystem/DataVaxiomPatientInsuranceForm/Employers/EmployerItem/Employer/Content/Options/Edit/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_DataVaxiomPatientInsuranceForm_Employers_EmployerItem_Employer_Content_Options_Edit_Content($id: numeric!) {
  vaxiom_employers_by_pk(id: $id) {
    id
    name
    contact_postal_address {
      id
      address_line1
      zip
      city
      state
    }
    contact_phone {
      id
      number
    }
    contact_email {
      id
      address
    }
  }
}

`